import { FC, useEffect } from 'react';
import { useSteps } from '@features/Steps';
import { ISettingsTransactionsDto } from '@shared/api';
import { splitCamelCase } from '@shared/utils';
import classNames from 'classnames';
import { getValueIcon } from './utils/getValueIcon';
import { transformDate } from './utils/transformDate';

interface AccountsInfoProps {
    fieldName: string;
    value: string | null;
    className?: string;
}

const AccountsInfo: React.FC<AccountsInfoProps> = (props) => {
    const { fieldName, value, className } = props;

    return (
        <div className={classNames('widget-transaction-view-drawer__info-item', className)}>
            <span className='widget-transaction-view-drawer__info-header'>{fieldName}:</span>
            <span className={classNames('widget-transaction-view-drawer__info-content', value, { nullable: !value })}>
                {getValueIcon(fieldName, value)} {value}
            </span>
        </div>
    );
};

export const GeneralTransactions: FC<{ transaction: ISettingsTransactionsDto }> = ({ transaction }) => {
    const { pushAllowedStep } = useSteps();

    const keyNames = {
        cusip: 'CUSIP',
        clearingAccount: 'Account Number',
    };

    useEffect(() => {
        pushAllowedStep(0);
        pushAllowedStep(1);
    }, [pushAllowedStep]);
    return (
        <div className='widget-transaction-view-drawer__content'>
            {Object.keys(transaction).map((keyName, index) => (
                <AccountsInfo
                    className={classNames({ noBorder: keyName === 'processed' })}
                    key={index}
                    fieldName={
                        keyNames[keyName as keyof typeof keyNames]
                            ? keyNames[keyName as keyof typeof keyNames]
                            : splitCamelCase(keyName, 'every-word')
                    }
                    value={transformDate(keyName, transaction) || '-'}
                />
            ))}
        </div>
    );
};
